/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          phone
          address
        }
      }
    }
  `)

  return (
    <>
      <StaticImage
        src="../images/coiffure.jpg"
        layout="fullWidth"
        quality={95}
        formats={["AUTO", "WEBP", "AVIF"]}
        alt="Coiffure"
        style={{ position: "fixed", width: "100%", height:"100%", zIndex: "-1" }}
      />
      <Header metadata={data.site.siteMetadata} />
      <div>
        <main>{children}</main>
        <footer
          style={{
            marginTop: `2rem`,
            background: "black",
            color: "white",
            minHeight: "5vh",
          }}
        >
          © {new Date().getFullYear()},
          {` `}
          <a style={{ fontWeight: "bold" }} href="https://www.cozy-codeur.fr/">
            Cozy Codeur - Développeur Freelance
          </a>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
